// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sorting[data-v-7568fe8e]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.icon-grey:not(:hover)>.icon-grey[data-v-7568fe8e],.sorting:not(:hover)>.icon-grey[data-v-7568fe8e]{color:#ddd}", ""]);
// Exports
module.exports = exports;
